import React from 'react';
import { useSelector } from 'react-redux';
import MainPage from './MainPage';

const MainPageComponent = (props) => {
    const isNavExtended = useSelector((state) => state.isNavExtended || false);

    return <MainPage {...props} isNavExtended={isNavExtended} />;
};

export default MainPageComponent;